module.exports = __webpack_public_path__ + "img/resource-tech-image-19.7a46284a.jpg";